import { grpc } from '@improbable-eng/grpc-web';
import { firebase } from '@app/src/firebase';

export interface GrpcMetadataInterceptor {
  onBeforeSend(metadata: grpc.Metadata): void;
  onReceive(metadata: grpc.Metadata): void;
}

declare global {
  interface Window {
    addGrpcMetadataInterceptor(interceptor: GrpcMetadataInterceptor): void;
  }
}

let grpcMetadataInterceptors: GrpcMetadataInterceptor[] = [];

window.addGrpcMetadataInterceptor = (interceptor: GrpcMetadataInterceptor) => {
  grpcMetadataInterceptors.push(interceptor);
};

const originalInvoke = grpc.invoke;

// helper refresh token and rebuild metadata
async function refreshAuthMetadata(oldMetadata: grpc.Metadata): Promise<grpc.Metadata> {
  const user = firebase.auth().currentUser;
  if (!user) return oldMetadata;
  const newToken = await user.getIdToken(true);
  const newMetadata = new grpc.Metadata(oldMetadata);
  // replace token
  newMetadata.set('token', newToken);
  return newMetadata;
}

//TODO: could come back and refactor this in the future cuz the way we patch grpc.invoke is a bit hacky
// but for now it works and we can move on
(<any>grpc).invoke = function (methodDescriptor: any, props: any) {
  let metadata = props.metadata || new grpc.Metadata();

  for (let interceptor of grpcMetadataInterceptors) {
    interceptor.onBeforeSend(metadata);
  }

  props.metadata = metadata;

  let originalOnHeaders = props.onHeaders;

  props.onHeaders = (headers: any) => {
    for (let interceptor of grpcMetadataInterceptors) {
      interceptor.onReceive(headers);
    }

    if (typeof originalOnHeaders === 'function') {
      return originalOnHeaders(headers);
    }
  };

  const originalOnEnd = props.onEnd;
  let hasRetried = false;
  props.onEnd = async (response: any) => {
    const isForbiddenError = response?.status?.code === 403;
    if (isForbiddenError && !hasRetried) {
      console.log('Received 403 error, attempting to refresh auth metadata and retry...');
      hasRetried = true;

      try {
        const newMetadata = await refreshAuthMetadata(metadata);
        const retryProps = { ...props, metadata: newMetadata, onEnd: originalOnEnd };
        // retry the gRPC call with the new metadata
        return originalInvoke.call(grpc, methodDescriptor, retryProps);
      } catch (error) {
        console.error('Error refreshing auth metadata:', error);
      }
    }

    if (typeof originalOnEnd === 'function') {
      return originalOnEnd(response);
    }
  };

  return originalInvoke.call(grpc, methodDescriptor, props);
};
